import { AxiosResponse } from 'axios';
import type { AxiosInstance } from 'axios';
import { inject } from '@aesop-fables/containr';
import { ApiServices } from '../ApiServices';
import { PricebookBundleMapping } from '../../models/PricebookData';

export class PricebookBundleApi {
  constructor(@inject(ApiServices.Axios) private axios: AxiosInstance) {}

  getByPrimaryPricebook(pricebookId: number): Promise<AxiosResponse<PricebookBundleMapping[]>> {
    return this.axios.get('pricebook-bundle/by-primary-pricebook', {
      params: { pricebookId },
    });
  }
}
